import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useLazyTenantPublicInfoQuery } from '@/app/api/generated';
import { REACT_APP_SERVICE_ID } from '@/config';
import { serviceProfile as jsonServiceProfile } from '@/profile/serviceProfile';
import { setServiceProfile } from '@/profile/serviceProfileSlice';
import { prepareServiceProfile } from '@/profile/util/prepareServiceProfile';

export const useServiceProfile = () => {
  const dispatch = useDispatch();
  const [fetchTenantPublicInfo] = useLazyTenantPublicInfoQuery();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchTenantPublicInfo({ serviceId: REACT_APP_SERVICE_ID })
      .unwrap()
      .then((data) => {
        const preparedServiceProfile = prepareServiceProfile(data);
        dispatch(setServiceProfile(preparedServiceProfile));
      })
      .catch((error) => {
        console.error('プロファイルの取得中にエラーが発生しました。', error);
        dispatch(setServiceProfile(jsonServiceProfile));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [dispatch, fetchTenantPublicInfo]);

  return { isLoading };
};
